module.exports = ".very-nice-shadow {\n  background: rgba(0, 0, 0, 0.5); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/push-notification/push-notif-image-modal/push-notif-image-modal.scss
// module id = ./src/app/push-notification/push-notif-image-modal/push-notif-image-modal.scss
// module chunks = main